// src/redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice"; // Correct path relative to store.js

export const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});
// Ensure you are using 'export const store' for the interceptor to access it.